<template>
  <div class="flex flex-col px-24 py-24">
    <div class="max-w-lg px-10 py-5 bg-gray-100 rounded">
      <p class="text-5xl">identity</p>
      <div class="flex items-center">
        <button
          class="px-6 py-2 mt-4 font-bold text-white bg-blue-500 rounded hover:bg-blue-700"
          @click="authenticateOidc('/')"
        >
          logga in
        </button>
      </div>
      <div class="mt-4 text-sm text-gray-600">
        {{ appversion }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "Login",
  data() {
    return {
      appversion: process.env.VUE_APP_APPVERSION
    };
  },
  methods: {
    ...mapActions("oidcStore", ["authenticateOidc"])
  }
};
</script>
